import { renderStatus, statusColor, type KioskRow } from "./kioskBuilder";
import { rowClass, useSortableRows } from "../../utils/useSortableRows";

interface Column {
  key: keyof KioskRow;
  label: string;
}

const COLUMNS: Column[] = [
  { key: "id", label: "Kiosk" },
  { key: "solution", label: "Solution" },
  { key: "environment", label: "Environment" },
  { key: "status", label: "Status" },
];

function sortValue(row: KioskRow, key: Column["key"]): string {
  return String(row[key] ?? "").toLowerCase();
}

export function KiosksTable({
  rows,
  selectedId,
  onSelect,
}: {
  rows: KioskRow[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}) {
  const { sorted, sortKey, sortDir, handleSort } = useSortableRows(rows, sortValue, "id" as Column["key"]);

  return (
    <table id="kiosksTable">
      <thead>
        <tr>
          {COLUMNS.map((col) => (
            <th key={col.key} onClick={() => handleSort(col.key)}>
              {col.label}
              {sortKey === col.key && (sortDir === 1 ? " ▲" : " ▼")}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sorted.map((row, index) => {
          return (
            <tr key={row.id} class={rowClass(row.id === selectedId, index)} onClick={() => onSelect(row.id)}>
              <td>{row.id}</td>
              <td>{row.solution ?? "—"}</td>
              <td>{row.environment ?? "—"}</td>
              <td style={{ backgroundColor: statusColor(row.status) }}>{renderStatus(row.status)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
